import styled, {keyframes} from 'styled-components';

export const IpTvPageStyleWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;

    :nth-child(1) {
        border-radius: 1rem;
    }
`;

export const WebCamWrapper = styled.div<{$isFullScreen: boolean}>`
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    ${({$isFullScreen}) =>
        $isFullScreen &&
        `
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 100;
        border-radius: 0px;
    `}
`;

const slideUp = keyframes`
    from {
        transform: translateY(30vh);
    }
    to {
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(30vh);
    }
`;

export const FullScreenIcon = styled.div<{$isFullScreen: boolean; $show: boolean; $focused: boolean}>`
    position: ${({$isFullScreen}) => ($isFullScreen ? 'fixed' : 'relative')};
    bottom: ${({$isFullScreen}) => ($isFullScreen ? '16px' : '38vh')};
    left: ${({$isFullScreen}) => ($isFullScreen ? '96vw' : '74vw')};
    z-index: 999;
    display: flex;
    background-color: #1f1f1f;
    padding: 0.7rem;
    border-radius: 1.25rem;
    transition: all 0.3s ease-in-out;
    animation: ${({$show}) => ($show ? slideUp : slideDown)} 0.5s forwards;
    width: 60px;
    height: 60px;
    border: ${({$focused}) => ($focused ? '3px solid #3FB5EC' : 'none')};
`;
